(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hgs-article"] && !Shopify.designMode) return;
  try {
    
// Posts are authored in Shopify's editor, which emits a bare <table> with no wrapper, so the
// scroll container is added here rather than asked of whoever writes the post.
(function () {
  function wrapTables(root) {
    (root || document).querySelectorAll('.hgs-article__body table').forEach(function (table) {
      if (table.parentElement && table.parentElement.classList.contains('hgs-article__table-scroll')) return;
      var box = document.createElement('div');
      box.className = 'hgs-article__table-scroll';
      table.parentNode.insertBefore(box, table);
      box.appendChild(table);
    });
  }
  wrapTables(document);
  document.addEventListener('shopify:section:load', function (e) { wrapTables(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hgs-contact"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hgs-contact__form').forEach(function (form) {
  form.addEventListener('submit', function () {
    var button = form.querySelector('button[type="submit"]');
    if (!button || button.classList.contains('loading')) return;
    button.classList.add('loading');
    button.setAttribute('aria-busy', 'true');
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hgs-guide-cta"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hgs-guidecta__cta').forEach(function (cta) {
  cta.addEventListener('click', function (event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    if (cta.classList.contains('loading')) return;
    cta.classList.add('loading');
    cta.setAttribute('aria-busy', 'true');
    var spinner = cta.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    if (window.hgsTrack) window.hgsTrack('guide_optin_click', { placement: 'product' });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hgs-guide"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hgs-leadguide__signup').forEach(function (form) {
  form.addEventListener('submit', function () {
    var button = form.querySelector('button[type="submit"]');
    if (!button || button.classList.contains('loading')) return;
    button.classList.add('loading');
    button.setAttribute('aria-busy', 'true');
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hgs-newsletter"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hgs-news__form').forEach(function (form) {
  form.addEventListener('submit', function () {
    var button = form.querySelector('button[type="submit"]');
    if (!button || button.classList.contains('loading')) return;
    button.classList.add('loading');
    button.setAttribute('aria-busy', 'true');
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    if (window.hgsTrack) window.hgsTrack('newsletter_subscribe', { placement: 'homepage' });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hgs-product-cbw"] && !Shopify.designMode) return;
  try {
    
// Shopify fills `recommendations` only on its own section-rendering request, so the rail is
// fetched after paint and swapped in. The skeleton it replaces is sized to the real card, so the
// swap does not move anything below it.
(function () {
  function load(mount) {
    var loading = mount.querySelector('[data-hgs-cbw-url]');
    if (!loading) return;
    var url = loading.dataset.hgsCbwUrl;
    if (!url) return;

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('recommendations ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.hgs-cbw-mount');
        // No recommendations for this product: drop the section entirely rather than leaving a
        // heading with an empty rail under it.
        mount.innerHTML = fresh && fresh.querySelector('.hgs-cbw:not(.hgs-cbw--loading)')
          ? fresh.innerHTML
          : '';
      })
      .catch(function () {
        mount.innerHTML = '';
      });
  }

  document.querySelectorAll('.hgs-cbw-mount').forEach(load);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hgs-product-related"] && !Shopify.designMode) return;
  try {
    
// Recommendations are only filled on Shopify's section-rendering request, so the grid is fetched
// after paint and swapped into a skeleton sized to the real card.
(function () {
  document.querySelectorAll('.hgs-related-mount').forEach(function (mount) {
    var loading = mount.querySelector('[data-hgs-related-url]');
    if (!loading) return;
    var url = loading.dataset.hgsRelatedUrl;
    if (!url) return;

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('recommendations ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.hgs-related-mount');
        mount.innerHTML = fresh && fresh.querySelector('.hgs-related:not(.hgs-related--loading)')
          ? fresh.innerHTML
          : '';
      })
      .catch(function () {
        mount.innerHTML = '';
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hgs-product-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('[data-hgs-reviews]');
  if (!section) return;

  var grid = section.querySelector('[data-hgs-reviews-grid]');
  var actions = section.querySelector('[data-hgs-reviews-actions]');
  var moreBtn = section.querySelector('[data-hgs-reviews-more]');
  var storeId = section.dataset.storeId;
  var productId = section.dataset.productId;
  var perPage = parseInt(section.dataset.perPage, 10) || 6;

  // `product_id`, not `productId`: the camelCase spelling is silently ignored by the API and
  // returns store-wide reviews, which would show another product's reviews on this page.
  var nextUrl =
    'https://storefront-api.loox.io/storefront/v1/store/' +
    encodeURIComponent(storeId) +
    '/product-reviews?product_id=' +
    encodeURIComponent(productId) +
    '&limit=' +
    perPage;

  var started = false;

  function esc(value) {
    var el = document.createElement('div');
    el.textContent = value == null ? '' : String(value);
    return el.innerHTML;
  }

  function stars(rating) {
    var out = '';
    for (var i = 1; i <= 5; i += 1) out += i <= Math.round(rating) ? '★' : '☆';
    return out;
  }

  function cardFor(review) {
    var photo = (review.media || []).filter(function (m) {
      return m.type === 'photo' && m.url;
    })[0];

    // A button, not a div with a click handler: it needs to be reachable by keyboard and
    // announced as something you can activate.
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'hgs-review-card' + (photo ? '' : ' hgs-review-card--text-only');
    card.setAttribute('aria-label', 'Read the full review');
    card.addEventListener('click', function () {
      openReview(review, photo);
    });

    var body = document.createElement('div');
    body.className = 'hgs-review-card__body';

    var rating = Number(review.rating) || 0;
    // Loox's storefront API abbreviates names to "Marcia H." and returns no location, so the
    // design's "Marcia, QLD" cannot be built from it. First name only is the closest this data
    // supports; the state would need Loox's merchant API (which needs a key) or matching each
    // review back to its order.
    var rawName = (review.reviewer && review.reviewer.name) || '';
    var name = rawName.split(' ')[0] || 'Verified buyer';

    var html =
      '<span class="hgs-review-card__stars" role="img" aria-label="' +
      esc(rating) +
      ' out of 5 stars">' +
      stars(rating) +
      '</span>' +
      '<p class="hgs-review-card__text">' +
      esc(review.body || '').replace(/\n+/g, '<br>') +
      '</p>' +
      '<span class="hgs-review-card__meta">' +
      '<span class="hgs-review-card__author">' +
      esc(name) +
      '</span>' +
      '</span>';

    if (review.reply && review.reply.body) {
      html +=
        '<p class="hgs-review-card__reply"><strong>Harwood’s replied:</strong> ' +
        esc(review.reply.body) +
        '</p>';
    }

    body.innerHTML = html;
    card.appendChild(body);

    // The hint is added after layout, once we can see whether the clamp actually cut anything.
    window.requestAnimationFrame(function () {
      var text = body.querySelector('.hgs-review-card__text');
      if (!text || text.scrollHeight <= text.clientHeight + 1) return;
      var more = document.createElement('span');
      more.className = 'hgs-review-card__more';
      more.textContent = 'Read full review';
      var meta = body.querySelector('.hgs-review-card__meta');
      body.insertBefore(more, meta);
    });

    if (photo) {
      var img = document.createElement('img');
      img.className = 'hgs-review-card__photo';
      img.loading = 'lazy';
      img.width = 140;
      img.height = 140;
      img.src = photo.url;
      img.alt = 'Photo from ' + name + '’s review';
      card.appendChild(img);
    }

    return card;
  }

  function openReview(review, photo) {
    var rating = Number(review.rating) || 0;
    var rawName = (review.reviewer && review.reviewer.name) || '';
    var name = rawName.split(' ')[0] || 'Verified buyer';

    var dialog = document.createElement('dialog');
    dialog.className = 'hgs-review-dialog';
    dialog.setAttribute('aria-label', 'Review by ' + name);

    var html =
      '<div class="hgs-review-dialog__inner">' +
      '<button type="button" class="hgs-review-dialog__close" aria-label="Close">&times;</button>' +
      '<span class="hgs-review-dialog__stars" role="img" aria-label="' +
      esc(rating) +
      ' out of 5 stars">' +
      stars(rating) +
      '</span>' +
      '<p class="hgs-review-dialog__text">' +
      esc(review.body || '').replace(/\n+/g, '<br>') +
      '</p>' +
      '<span class="hgs-review-dialog__author">' +
      esc(name) +
      '</span>';

    if (photo) {
      html +=
        '<img class="hgs-review-dialog__photo" src="' +
        esc(photo.url) +
        '" alt="Photo from ' +
        esc(name) +
        '’s review">';
    }

    if (review.reply && review.reply.body) {
      html +=
        '<p class="hgs-review-dialog__reply"><strong>Harwood’s replied:</strong> ' +
        esc(review.reply.body) +
        '</p>';
    }

    html += '</div>';
    dialog.innerHTML = html;

    dialog.querySelector('.hgs-review-dialog__close').addEventListener('click', function () {
      dialog.close();
    });
    // Clicking the backdrop closes it. The check is on the target being the dialog itself, since
    // clicks inside the panel bubble up to the same element.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', function () {
      dialog.remove();
    });

    document.body.appendChild(dialog);
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function render(reviews, replace) {
    if (replace) grid.innerHTML = '';
    reviews.forEach(function (review) {
      // Belt and braces against the product_id trap: never render a review belonging to another
      // product, whatever the API returns.
      if (review.product && String(review.product.id) !== String(productId)) return;
      grid.appendChild(cardFor(review));
    });
  }

  function drop() {
    // No reviews, or the API is unreachable: remove the section rather than leave a heading over
    // an empty grid, or a skeleton that never resolves.
    section.remove();
  }

  function load(url, replace) {
    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('loox ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var reviews = data.reviews || [];
        if (replace && reviews.length === 0) {
          drop();
          return;
        }
        render(reviews, replace);
        var pagination = data.pagination || {};
        nextUrl = pagination.hasMore ? pagination.nextPageUrl : null;
        actions.hidden = false;
        moreBtn.hidden = !nextUrl;
      })
      .catch(function () {
        if (replace) drop();
      });
  }

  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      if (!nextUrl) return;
      moreBtn.disabled = true;
      load(nextUrl, false).then(function () {
        moreBtn.disabled = false;
      });
    });
  }

  // Fetched when the section nears the viewport: the reviews sit well below the fold, and this
  // keeps their request off the critical path for the buy box.
  function start() {
    if (started) return;
    started = true;
    load(nextUrl, true);
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          start();
        });
      },
      { rootMargin: '600px 0px' }
    );
    observer.observe(section);
  } else {
    start();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
